import React from 'react'
import SettingTextToSpeech from './SettingTextToSpeech'
import SettingAudioSound from './SettingAudioSound'
import styled from 'styled-components'

const PageContainer = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const PageHeader = styled.div`
  margin-bottom: 30px;
  text-align: center;
`;

const Title = styled.h1`
  color: #5a54a2;
  font-size: 28px;
  margin-bottom: 10px;
`;

const Subtitle = styled.p`
  color: #666;
  font-size: 16px;
`;

const SettingsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  
  @media (min-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const SettingCard = styled.div`
  background: white;
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
`;

function SettingTTS() {
  return (
    <PageContainer>
      <PageHeader>
        <Title>Text & Audio Settings</Title>
        <Subtitle>Configure your text-to-speech and audio notification preferences</Subtitle>
        <Subtitle style={{ color: "red" }}>ຖ້າຫາກວ່າສຽງບໍ່ໄດ້ ກະລຸນາຕີດຕໍ່ທີມຊັບພອສເພື່ອການຕັ້ງຄ່າທີ່ Advanced ຍີ່ງຂື້ນ</Subtitle>
      </PageHeader>
      
      <SettingsContainer>
        <SettingCard>
          <SettingTextToSpeech />
        </SettingCard>
        
        <SettingCard>
          <SettingAudioSound />
        </SettingCard>
      </SettingsContainer>
    </PageContainer>
  )
}

export default SettingTTS
